'use strict';

const Backbone = require('backbone');
const FormQuestion = require('../models/form-question').default;

export default Backbone.Collection.extend({
  model: FormQuestion,

  validateFormQuestions: function() {
    let valid = true;
    this.models.forEach((model) => {
      if (!model.isValid()) {
        valid = false;
      }
    });

    return valid;
  },

  getErrors: function() {
    let errors = [];
    this.models.forEach((model) => {
      if (model.validationError) {
        errors.push(model.validationError);
      }
    });

    return errors;
  },

  /**
   * Convert the collection of questions into responses.
   *
   * @return {Array}
   */
  toResponses: function() {
    const responses = [];

    this.models.forEach((question) => {
      responses.push(question.toResponse());
    });

    return responses;
  },
});
